import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { PageInfo } from '../../interfaces/pageInfo';
import { AsyncPipe } from '@angular/common';

interface Entry {
  title: Observable<string>;
  link: any[];
  queryParams?: Params;
  last: boolean;
}

@Component({
    selector: 'gbc-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [
    RouterLink,
    AsyncPipe
],
})
export class BreadcrumbComponent implements OnChanges, OnInit {
  @Input()
  private readonly pageInfo: PageInfo;

  public entries: Entry[] = [];

  constructor() {}

  ngOnChanges() {
    this.updateEntries();
  }

  ngOnInit() {
    this.updateEntries();
  }

  updateEntries() {
    if (this.pageInfo) {
      this.entries = this.pageToEntries(this.pageInfo);
    }
  }

  entriesTrackByFn(_index: any, item: Entry) {
    return item.link;
  }

  pageToEntries(page: PageInfo): Entry[] {
    const entries: Entry[] = [];
    let p: PageInfo | null = page;
    while (p) {
      entries.unshift({
        title: p.title,
        last: false,
        link: p.link,
        queryParams: p.queryParams,
      });
      p = p.parent;
    }
    entries[entries.length - 1].last = true;
    return entries;
  }
}
